import { render } from "./logo-talenta-color.svg?vue&type=template&id=13e8dc80"
const script = {}
script.render = render

export default script